import AppSimpleSelect from 'components/FormElements/AppSimpleSelect';
import { Vehicle } from 'further-types/lp/vehicle';
import { Control, Controller, Path } from 'react-hook-form';

type VehicleSelectorProps<T extends Record<'vehicleId', string>> = {
  selectedVehicle: Vehicle;
  control?: Control<T>;
};

const VehicleSelector = <T extends Record<'vehicleId', string>>({
  selectedVehicle,
  control,
}: VehicleSelectorProps<T>) => {
  const selectOptions = [
    {
      value: selectedVehicle._id,
      label: selectedVehicle.vehicleName,
    },
  ];

  if (!control) {
    return (
      <AppSimpleSelect
        fullWidth
        disabled
        options={selectOptions}
        value={selectedVehicle._id}
      />
    );
  }

  return (
    <Controller
      name={'vehicleId' as Path<T>}
      control={control}
      render={({ field: { ref, ...rest } }) => (
        <AppSimpleSelect fullWidth disabled options={selectOptions} {...rest} />
      )}
    />
  );
};

export default VehicleSelector;
